import React, { useState, useEffect } from 'react';
import loggerIntegrationApi from '../../../services/apiServices/loggerIntegrationApi';
import { setLoading } from '../../../services/redux/loadingSlice';
import { useDispatch } from 'react-redux';
import configService from '../../../services/configService';
import Pagination from '../../../components/common/Pagination/Pagination'; 
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';
import FilterComponent from '../../../components/admin/FilterComponent/FilterComponent';
import { useNavigate } from 'react-router-dom';


const LogIntegrationListPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItens, setTotalItens] = useState(0);
    const quantity = configService.getDefaultNumberOfItemsTable(); 
    const [showFilters, setShowFilters] = useState(false);
    const toggleFilters = () => setShowFilters(prev => !prev);
    const orderBy = "Created:Desc";

    useEffect(() => {
        const fetchLogs = async () => {
            dispatch(setLoading(true));
            try {
                const response = await loggerIntegrationApi.getLoggerIntegrationPaginated({ page, quantity, orderBy, term: searchTerm });
                setItems(response.Results);
                setTotalPages(response.TotalPages);
                setTotalItens(response.TotalCount);
            } catch (error) {
                toast.error('Erro ao buscar os itens.');
            } finally {
                dispatch(setLoading(false));
            }
        };
        fetchLogs();
    }, [page, quantity, searchTerm, dispatch]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const search = ({term} = {}) => {
        setSearchTerm(term);
    }

    const exportFunction = async (term) => {
        try {
            dispatch(setLoading(true));
            const response = await loggerIntegrationApi.exportLogs({ term: term });
            
            if (response.Status === 200 && response.Object) {
                window.open(response.Object, "_blank");
                toast.success('Relatório gerado com sucesso!');
            } else {
                toast.error('Erro ao gerar o relatório');
            }
        } catch (error) {
            toast.error('Erro ao gerar o relatório');
        }
        finally{
            dispatch(setLoading(false));
        }
    };

    const openItem = (code) => {
        navigate(`${code}`);
    }

    return (
    <div className="container-admin-page">
        <div className='title-with-options'>
            <h1>Lista de Integrações</h1>

            <button className="main-button" onClick={toggleFilters}>
                {showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros'}
            </button>
        </div>

        {showFilters && (
            <div className='container-admin-page-filters div-with-border'>
                <h3>Filtros</h3>
                <FilterComponent 
                    placeHolder={'Nº do pedido'} 
                    showTermFilter={true} 
                    submitFilter={search} 
                    exportFunction={exportFunction}/>
            </div>
        )}


        <div className='container-admin-page-table div-with-border'>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Nº pedido</th>
                        <th>Texto</th>
                        <th>Criado</th>
                    </tr>
                </thead>
                <tbody>
                {items.map((item) => (
                    <tr key={item.Id}>
                        <td data-label='Id'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {item.Id}
                            </span>
                        </td>
                        <td data-label='Nº pedido'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {item.OrderId}
                            </span>
                        </td>
                        <td data-label='Texto'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {item.TextLog.length > 100 
                                    ? `${item.TextLog.substring(0, 100)}...` 
                                    : item.TextLog}
                            </span>
                        </td>
                        <td data-label='Criado'>
                            <span className='option-link' onClick={() => openItem(`${item.Id}`)}>
                                {putDateOnPattern(item.Created)}
                            </span>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <sub>Total de Integrações: {totalItens}</sub>
            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    </div>
    );
};

export default LogIntegrationListPage;
